import { useDevTools } from "$global-providers/dev-tools-provider/provider";
import { styled } from "@material-ui/core";
import { useRef, useState } from "react";

const AppVersionListItem = styled("p")(({ theme }) => ({
  margin: 0,
  color: theme.palette.grey[500],
  fontSize: "0.8rem",
  paddingLeft: theme.spacing(2),
  // cursor: "pointer", // keep hidden
}));

export const AppVersionWithDevToolsToggle: React.FC<{ version: string }> = ({
  version,
}) => {
  const { toggleDevTools } = useDevTools();
  const [_clickCount, setClickCount] = useState(0);
  const timerRef = useRef<NodeJS.Timeout | null>(null);

  const handleClick = () => {
    if (timerRef.current) clearTimeout(timerRef.current);
    setClickCount((prev) => {
      const newCount = prev + 1;
      if (newCount >= 5) {
        toggleDevTools();
        return 0;
      }
      timerRef.current = setTimeout(() => {
        setClickCount(0);
      }, 5000);
      return newCount;
    });
  };

  return (
    <AppVersionListItem onClick={handleClick}>{version}</AppVersionListItem>
  );
};
